var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M6,7 L6,6 L7,6 L7,7 L6,7 Z M9,13 L9,12 L10,12 L10,13 L9,13 Z M12,7 L12,6 L13,6 L13,7 L12,7 Z M9,7 L9,6 L10,6 L10,7 L9,7 Z M6,9 L6,8 L7,8 L7,9 L6,9 Z M3,9 L3,8 L4,8 L4,9 L3,9 Z M12,9 L12,8 L13,8 L13,9 L12,9 Z M9,9 L9,8 L10,8 L10,9 L9,9 Z M6,11 L6,10 L7,10 L7,11 L6,11 Z M3,11 L3,10 L4,10 L4,11 L3,11 Z M12,11 L12,10 L13,10 L13,11 L12,11 Z M9,11 L9,10 L10,10 L10,11 L9,11 Z M6,13 L6,12 L7,12 L7,13 L6,13 Z M3,13 L3,12 L4,12 L4,13 L3,13 Z M13,1 L16,1 L16,15 L0,15 L0,1 L3,1 L3,0 L4,0 L4,1 L12,1 L12,0 L13,0 L13,1 Z M3,2 L1,2 L1,4 L15,4 L15,2 L13,2 L13,3 L12,3 L12,2 L4,2 L4,3 L3,3 L3,2 Z M1,14 L15,14 L15,5 L1,5 L1,14 Z"}));
}

Calendar.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Calendar;

Calendar.default = Calendar;
